import { FIELD_TYPES } from '../constants';
export const hasMultilineAddress = form => {
  return Boolean([...((form == null ? void 0 : form.fields) || []), ...((form == null ? void 0 : form.deletedFields) || [])].some(field => {
    var _field$view, _field$view2;
    return ((_field$view = field.view) == null ? void 0 : _field$view.fieldType) === FIELD_TYPES.MULTILINE_ADDRESS || ((_field$view2 = field.view) == null ? void 0 : _field$view2.fieldType) === FIELD_TYPES.BOOKINGS_ADDRESS;
  }));
};
export const isMultilineAddressField = field => {
  var _field$view3, _field$view4;
  return ((_field$view3 = field.view) == null ? void 0 : _field$view3.fieldType) === FIELD_TYPES.MULTILINE_ADDRESS || ((_field$view4 = field.view) == null ? void 0 : _field$view4.fieldType) === FIELD_TYPES.BOOKINGS_ADDRESS;
};
//# sourceMappingURL=multiline-address.js.map